export enum DRIVING_LICENCE_TYPE_UK {
  FULL_UK = 'FullUK',
  PROVISIONAL_UK = 'ProvisionalUK',
  EU = 'EU',
  INTERNATIONAL = 'International',
  NONE = 'None',
  OTHER = 'Other',
}
